import { render, staticRenderFns } from "./answerPage.vue?vue&type=template&id=a146fae8&scoped=true"
import script from "./answerPage.vue?vue&type=script&lang=js"
export * from "./answerPage.vue?vue&type=script&lang=js"
import style0 from "./answerPage.vue?vue&type=style&index=0&id=a146fae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a146fae8",
  null
  
)

export default component.exports